import type { PropsWithChildren } from 'react';
import { VStack } from '~/components/stack';

export function OrderedList({ children }: PropsWithChildren) {
  return (
    <ol className="flex flex-col gap-4 list-decimal list-inside text-lg [&_ul]:pl-8">
      {children}
    </ol>
  );
}

export function UnorderedList({ children }: PropsWithChildren) {
  return (
    <ul className="flex flex-col gap-2 py-4 list-disc list-inside text-lg">
      {children}
    </ul>
  );
}

export function ListItem({ children }: PropsWithChildren) {
  return <li>{children}</li>;
}

export function LegalSection({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  return (
    <VStack className="gap-4">
      <h2 className="text-2xl font-semibold">{title}</h2>
      <div>{children}</div>
    </VStack>
  );
}

export function LegalSubsection({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  return (
    <VStack className="gap-4 pt-4">
      <h2 className="text-xl font-semibold">{title}</h2>
      <div>{children}</div>
    </VStack>
  );
}

export function LegalParagraph({ children }: PropsWithChildren) {
  return <p className="text-lg leading-normal">{children}</p>;
}
